import React from 'react';
import cn from 'classnames';
import styles from './NavBar.module.sass'
import Image from "../../Image";
import poses from "../../../assets/Poses_Icon_Grey.png";
import posesSelected from "../../../assets/Poses_Icon_Blue.png";
import backgrounds from "../../../assets/Backgrounds_Icon_Grey.png";
import backgroundsSelected from "../../../assets/Backgrounds_Icon_Blue.png";
import foregrounds from "../../../assets/Overlays_Icon_Grey.png";
import foregroundsSelected from "../../../assets/Overlays_Icon_Blue.png";

const NavBar = ({ selectedIcon, setSelectedIcon }) => {
  return (
    <div className={styles.navContainer}>
      <div className={styles.innerWrapper}>
        <div className={cn(styles.iconContainer, selectedIcon === 'poses' && styles.selected)}>
          <Image
            src={selectedIcon === 'poses' ? posesSelected : poses}
            alt="View poses"
            classes={styles.icon}
            onClick={() => setSelectedIcon('poses')}
          />
          
        </div>
        <div className={cn(styles.iconContainer, selectedIcon === 'backgrounds' && styles.selected)}>
          <Image
            src={selectedIcon === 'backgrounds' ? backgroundsSelected : backgrounds}
            alt="View backgrounds"
            classes={styles.icon}
            onClick={() => setSelectedIcon('backgrounds')}
          />
          
        </div>
        <div className={cn(styles.iconContainer, selectedIcon === 'foregrounds' && styles.selected)}>
          <Image
            src={selectedIcon === 'foregrounds' ? foregroundsSelected : foregrounds}
            alt="View foregrounds"
            classes={styles.icon}
            onClick={() => setSelectedIcon('foregrounds')}
          />
          
        </div>
      </div>
    </div>
  )
}

export default NavBar;
